import React from 'react'

// hooks
import { useEffect, useState } from 'react'

// store
import { getWorkflowTrialById } from '../../../reducer/slices/workflow/get-workflow-by-id';
import { useDispatch, useSelector } from 'react-redux';

//  icons
import Sunrise from "../../../assets/icons/sunrise";
import Sunnoon from "../../../assets/icons/sunnoon";
import Sunset from "../../../assets/icons/sunset";

// constants
import { generateTimeSlots, getFullDayName, roundToNextSlot } from './constants';

// api
import { getCalendarSlotStartTime } from '../../../js/api/events';

// components
import { Toast } from '../../common/toast/toast';
import AddEvent from './add-event'

const AddEventContainer = ({  isCalenderRecriuterLoading, trialInfo, isAddEventOpen, closeAddEvent, toasts,
    setToasts, removeToast, trialRecruiter, recruiterData, operationalData }) => {
    const now = new Date();
    const dispatch = useDispatch();
    const [selectedRecriuter, setSelectedRecriuter] = useState();
    const [currentMonth, setCurrentMonth] = useState(now.getMonth());
    const [currentYear, setCurrentYear] = useState(now.getFullYear());
    const [selectedDay, setSelectedDay] = useState(getFullDayName(new Date(currentYear, currentMonth, now.getDate())));
    const [availableTimes, setAvailableTimes] = useState([
        "00:00", "00:30", "01:00", "01:30", "02:00", "02:30",
        "03:00", "03:30", "04:00", "04:30", "05:00", "05:30",
        "06:00", "06:30", "07:00", "07:30", "08:00", "08:30",
        "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
        "12:00", "12:30", "13:00", "13:30", "14:00", "14:30",
        "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
        "18:00", "18:30", "19:00", "19:30", "20:00", "20:30",
        "21:00", "21:30", "22:00", "22:30", "23:00", "23:30"
    ])
    const [selectedDate, setSelectedDate] = useState(now.getDate());
    const [operationDay, setOperationDay] = useState()
    const [slotStartTime, setSlotStartTime] = useState();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const roundedMinute = currentMinute < 30 ? "00" : "30";
    const [formattedTime, setFormattedTime] = useState(`${String(currentHour).padStart(2, "0")}:${roundedMinute}`)
    const [slotFilter, setSlotFilter] = useState("morning");
    const [selectedTime, setSelectedTime] = useState(
        availableTimes.includes(formattedTime) ? formattedTime : availableTimes[0]
    );
    const timeSlotGroups = {
        morning: { icon: <Sunrise />, start: 8 * 60, end: 11 * 60 },
        afternoon: { icon: <Sunnoon />, start: 11 * 60, end: 14 * 60 },
        evening: { icon: <Sunset />, start: 14 * 60, end: 17 * 60 },
    };
    // const trialRecruiter = useSelector(state => state.workflow_by_trial_id.data);
    // const [recruiterData, setRecruiterData] = useState(trialRecruiter && trialRecruiter.assignedRecruiter && trialRecruiter.assignedRecruiter.filter((val) => val.hasCalendar));
    // const [operationalData, setOperationalData] = useState(trialRecruiter && trialRecruiter.operatingHoursJson && trialRecruiter.operatingHoursJson)
    const [slotLoader, setSlotLoader] = useState(false)

    useEffect(() => {
        const id = trialInfo.trialID;
        dispatch(getWorkflowTrialById({ id }))
    }, []);

    

  


    useEffect(() => {
        const operationDay = operationalData && operationalData.length && operationalData.filter((item) => item.day === selectedDay)
        operationalData && operationalData.length && setOperationDay(operationDay[0].time)
        const generateSlots = operationalData && operationalData.length && generateTimeSlots(operationDay[0].time)
        operationalData && operationalData.length && setAvailableTimes(generateSlots)
    }, [operationalData])

    useEffect(() => {
        getCalendarSlotStartTime(selectedRecriuter, setSlotStartTime, setSlotLoader)
    }, [selectedRecriuter])

    useEffect(() => {
        if (slotStartTime) {
            setFormattedTime(roundToNextSlot(slotStartTime.startTime))
        }
    }, [slotStartTime])

    return (
        <div>
            <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
                {toasts.map((toast) => (
                    toast.type
                        ===
                        "error" ?
                        <Toast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} /> : ""
                ))}
                <AddEvent
                    isCalenderRecriuterLoading={isCalenderRecriuterLoading}
                    toasts={toasts}
                    setToasts={setToasts}
                    currentMonth={currentMonth}
                    currentYear={currentYear}
                    selectedDay={selectedDay}
                    slotStartTime={slotStartTime}
                    setCurrentMonth={setCurrentMonth}
                    setCurrentYear={setCurrentYear}
                    setSelectedDay={setSelectedDay}
                    setSelectedDate={setSelectedDate}
                    setSlotStartTime={setSlotStartTime}
                    setSelectedTime={setSelectedTime}
                    setSlotFilter={setSlotFilter}
                    slotFilter={slotFilter}
                    selectedTime={selectedTime}
                    selectedDate={selectedDate}
                    currentHour={currentHour}
                    currentMinute={currentMinute}
                    roundedMinute={roundedMinute}
                    formattedTime={formattedTime}
                    timeSlotGroups={timeSlotGroups}
                    patient={trialInfo}
                    onCancel={closeAddEvent}
                    recruiters={recruiterData}
                    selectedRecriuter={selectedRecriuter}
                    setSelectedRecriuter={setSelectedRecriuter}
                    availableTimes={availableTimes}
                    slotLoader={slotLoader}
                    operationalData={operationalData}
                    setSlotLoader={setSlotLoader}
                    now={now}
                    id={trialInfo.trialID}
                />
            </div>
        </div>
    )
}

export default AddEventContainer